/**
 * Escape a user-supplied search term for safe inclusion in a PostgREST
 * .or() / .ilike() predicate string.
 *
 * Handles two attack surfaces:
 *   1. ILIKE wildcards — % and _ in user input would otherwise be
 *      treated as match-anything wildcards. Backslash is the default
 *      ESCAPE char under PostgREST .or() string form.
 *   2. PostgREST .or() reserved chars — , ( ) " break the predicate
 *      grammar (comma causes PGRST100 "failed to parse logic tree";
 *      parens nest predicates; double-quote is the string delimiter).
 *      Solved by wrapping the full pattern in double quotes; inner
 *      quotes escaped as \".
 *
 * Escape order matters: wildcards first (backslash IS the escape
 * char, so escaping % and _ adds backslashes), then existing inner
 * quotes — outer wrapper is applied last.
 *
 * Returns the FULL wrapped pattern (including %...% substring
 * wildcards and outer double-quotes), ready for direct concatenation
 * into a .or() predicate.
 *
 * @see Day 73 P4.1 — C.7 + F56
 */
export function escapeOrIlikeTerm(raw: string): string {
  const wildcardEscaped = raw.replace(/[\\%_]/g, (c) => '\\' + c);
  const quoteEscaped = wildcardEscaped.replace(/"/g, '\\"');
  return `"%${quoteEscaped}%"`;
}
